import { Box } from "@mui/material";

import { Column, Row } from "../../containers";
import { Text, TextSkeleton } from "../../typography";
import { TableColumn, TableRow } from "../types";

export function findCardColumn<T>(columns: TableColumn<T>[], dataIndex: string | undefined) {
    if (!dataIndex) return undefined;
    return columns.find((c) => c.dataIndex === dataIndex);
}

function CardStatLabel({ title, loading }: { title: string | JSX.Element; loading?: boolean }) {
    if (loading) return <TextSkeleton variant="body2" width="50px" />;
    if (typeof title !== "string") return <>{title}</>;
    return (
        <Text variant="body2" color="caption" sx={{ whiteSpace: "nowrap" }}>
            {title}
        </Text>
    );
}

export function CardStat<T>({
    column,
    row,
    index = 0,
    loading
}: {
    column: TableColumn<T>;
    row?: TableRow<T>;
    index?: number;
    loading?: boolean;
}) {
    return (
        <Column spacing={0.25} sx={{ minWidth: 0, alignItems: "flex-start" }}>
            <CardStatLabel title={column.title} loading={loading || !row} />
            {loading || !row ? (
                <TextSkeleton variant="body1" width="48px" />
            ) : (
                <Box sx={{ display: "flex", alignItems: "center" }}>{column.render(row, index)}</Box>
            )}
        </Column>
    );
}

export function CardStatRow<T>({
    columns,
    row,
    index,
    loading
}: {
    columns: TableColumn<T>[];
    row?: TableRow<T>;
    index?: number;
    loading?: boolean;
}) {
    if (!columns.length) return null;
    return (
        <Row sx={{ gap: 2, flexWrap: "wrap", alignItems: "flex-start" }}>
            {columns.map((column) => (
                <CardStat key={column.dataIndex} column={column} row={row} index={index} loading={loading} />
            ))}
        </Row>
    );
}
